export default __webpack_public_path__ + "static/media/email.d23977d0.svg";